import React from 'react';
import AdminDashboard from '../AdminDashboard';

const BoothsPage = () => <AdminDashboard forcedTab="booths" embedded />;

export default BoothsPage;
